import CommandCenterStore from "./CommandCenter/CommandCenterStore";

/** App stores for the Home (command-center) area — spread in appStoresConfig. */
const homeStoreList = [{ name: "commandCenterStore", store: CommandCenterStore }];

export default homeStoreList;
